import { render, staticRenderFns } from "./editServerLabel.vue?vue&type=template&id=6fb65990&scoped=true&"
import script from "./editServerLabel.vue?vue&type=script&lang=js&"
export * from "./editServerLabel.vue?vue&type=script&lang=js&"
import style0 from "./editServerLabel.vue?vue&type=style&index=0&id=6fb65990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb65990",
  null
  
)

component.options.__file = "editServerLabel.vue"
export default component.exports